package com.github.jangalinski.tabweb._foundation

import kotlin.String

public enum class TabwebColors(
  public val `value`: String,
) {
  AZURE("azure"),
  BLUE("blue"),
  CYAN("cyan"),
  GREEN("green"),
  INDIGO("indigo"),
  LIME("lime"),
  ORANGE("orange"),
  PINK("pink"),
  PURPLE("purple"),
  RED("red"),
  TEAL("teal"),
  YELLOW("yellow"),
  WHITE("white"),
  BLACK("black"),
  ;
}
